import { IFilter } from '../../types/filters';
import { FlatRoomsContainer } from '../../containers/advancedFilters/FlatRoomsContainer';

export const flatRooms: IFilter = {
  component: FlatRoomsContainer,
};
